export default (state = null) => state;
